<div class="no-access-container">
  <div class="no-access">
    <div class="error-img">
      <img src="assets/images/common/error-image.svg" width="450px" alt="No access" />
    </div>

    <div class="heading-generic">{{ 'noAccess.heading' | labelsProvider }}</div>

    <div class="description">
      <p>{{ 'noAccess.descriptionLine1' | labelsProvider }}</p>
      <p>{{ 'noAccess.descriptionLine2' | labelsProvider }}</p>
    </div>

    <div class="contact">
      {{ 'noAccess.contactAdmin' | labelsProvider }}
      <a href="mailto:support@zenity.io">{{ 'noAccess.supportEmail' | labelsProvider }}</a>
    </div>
  </div>
</div>
